import { api } from "../../shared/api/axios";

export async function fetchColletoLockers() {
  const { data } = await api.get("/colletos/lockers-colleto");
  return data;
}

export async function fetchReservasByColleto(colletoId) {
  const { data } = await api.get(`/colletos/list-by-colleto/${colletoId}`);
  return data;
}
